import React, { useEffect } from "react";
import "./MedicalSupport.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import medicalImg from "../../Asset/Images/MedicalSupport.jpeg";

const MedicalSupport = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 medical detail cards
  const medicalPoints = [
    "med_support.point1",
    "med_support.point2",
    "med_support.point3",
    "med_support.point4",
    "med_support.point5",
    "med_support.point6",
    "med_support.point7",
    "med_support.point8"
  ];

  return (
    <div className="medical_page">
      {/* HERO SECTION */}
      <section className="medical_hero">
        <div className="medical_card_container">
          <div className="medical_content" data-aos="fade-right">
            <span className="service_tag">{t('med_support.service_tag')}</span>
            <h1>
              {t('med_support.title_start')} <span>{t('med_support.title_end')}</span>
            </h1>
            <p>{t('med_support.hero_desc')}</p>
          </div>

          <div className="medical_image" data-aos="fade-left">
            <img src={medicalImg} alt={t('med_support.title_start') + " " + t('med_support.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="medical_details">
        <h2 data-aos="fade-up">{t('med_support.details_title')}</h2>
        <div className="medical_grid">
          {medicalPoints.map((key, index) => (
            <div className="medical_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="medical_cta" data-aos="fade-up">
        <h2>{t('med_support.cta_title')}</h2>
        <p>{t('med_support.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default MedicalSupport;